<div class="input-block custom-dropdown-control">
    <label class="input-label">{{dropDownSettings?.label}}<span class="validation-field">*</span></label>
    <div class="desc">{{dropDownSettings?.description}}</div>
    <div class="selected-states" [class.readonly]="dropDownSettings.readOnly">
        <span *ngFor="let state of selectedStates">
            <span *ngIf="dropDownSettings.multiple">{{state.stateCode}}</span>
            <span *ngIf="!dropDownSettings.multiple">{{state.stateName}}</span>
            <a href="javascript:void(0)" (click)="onSelectionChange(state.stateId)" *ngIf="dropDownSettings.multiple">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 28 28">
                    <rect width="28" height="28" rx="6" fill="none" />
                    <g transform="translate(4 4)">
                        <rect width="20" height="20" fill="none" />
                        <path
                            d="M10,11.229,5.979,15.25a.789.789,0,0,1-.6.24.863.863,0,0,1-.6-.261.88.88,0,0,1,0-1.229l4-4L4.75,5.979a.8.8,0,0,1-.24-.614.875.875,0,0,1,.261-.615A.88.88,0,0,1,6,4.75l4,4.021L14.021,4.75A.869.869,0,0,1,15.25,5.979L11.229,10l4.021,4.021a.855.855,0,0,1,0,1.208.88.88,0,0,1-1.229,0Z"
                            transform="translate(-0.005 0.005)" fill="#757575" />
                    </g>
                </svg>
            </a>
        </span>
        <span class="select-states" *ngIf="selectedStates.length == 0">{{dropDownSettings?.label}}</span>
    </div>
    <div class="unselect-states" *ngIf="!dropDownSettings.readOnly">
        <div class="select-all" *ngIf="dropDownSettings.multiple">
            <div class="d-flex align-items-center" (click)="onSelectionChange(0)">
            <input [ngClass]="{'clear-all' : selectedStates.length == this.states.length}" type="checkbox" class="mr-1">
            <label *ngIf="selectedStates.length != this.states.length">Select All</label>
            <label *ngIf="selectedStates.length == this.states.length">Clear All</label>
            </div>
            
        </div>
        <div class="row m-0">
            <span class="col-md-6 col-lg-4 col-xl-{{12/dropDownSettings.column | number : '1.0-0'}}" (click)="onSelectionChange(states.stateId)" *ngFor="let states of unSelectedStates; let i = index">
                <input class="mr-1" type="checkbox" name="states">
                <label for=""> {{ states.stateNameWithStateCode }}</label>
            </span>
        </div>
    </div>
</div>